export default function Linkedin({ isHover }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill={isHover ? '#fff' : '#292929'} />
      <g clipPath="url(#clip0_1574_291)">
        <path
          d="M11 13.4199C11 12.8427 11.2027 12.3665 11.6081 11.9914C12.0135 11.6162 12.5405 11.4286 13.1892 11.4286C13.8263 11.4286 14.3417 11.6133 14.7355 11.9827C15.1409 12.3637 15.3436 12.86 15.3436 13.4719C15.3436 14.026 15.1467 14.4877 14.7529 14.8572C14.3475 15.2381 13.8147 15.4286 13.1544 15.4286H13.1371C12.5 15.4286 11.9846 15.2381 11.5907 14.8572C11.1969 14.4762 11 13.9971 11 13.4199ZM11.2259 28.5714V17.0043H15.083V28.5714H11.2259ZM17.2201 28.5714H21.0772V22.1126C21.0772 21.7085 21.1236 21.3968 21.2162 21.1775C21.3784 20.785 21.6245 20.4531 21.9546 20.1818C22.2847 19.9105 22.6988 19.7749 23.1969 19.7749C24.4942 19.7749 25.1429 20.6465 25.1429 22.3896V28.5714H29V21.9394C29 20.2309 28.5946 18.9351 27.7838 18.052C26.973 17.1688 25.9015 16.7273 24.5695 16.7273C23.0753 16.7273 21.9112 17.368 21.0772 18.6494V18.684H21.0598L21.0772 18.6494V17.0043H17.2201C17.2432 17.3737 17.2548 18.5224 17.2548 20.4502C17.2548 22.3781 17.2432 25.0851 17.2201 28.5714Z"
          fill={isHover ? '#121212' : '#F6F6F6'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1574_291">
          <rect
            width="16.3636"
            height="16.3636"
            fill={isHover ? '#121212' : '#F6F6F6'}
            transform="translate(11.8184 11.8181)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
